import React from 'react';
import UseCaseTemplate from '@/components/use-cases/UseCaseTemplate';

const summary = [
  'Enterprise governance for patient‑trust signals',
  'Compliant workflows for sensitive feedback',
  'AI visibility accuracy across service lines'
];

const challenges = [
  {
    title: 'Regulatory and privacy sensitivity',
    description: 'Responses must be careful, compliant, and non‑disclosive.'
  },
  {
    title: 'High‑stakes reputation risk',
    description: 'Feedback affects patient choice, referrals, and clinician trust.'
  },
  {
    title: 'AI visibility risk',
    description: 'AI systems may surface outdated or incorrect care information.'
  }
];

const pillars = [
  {
    title: 'Governed Response Frameworks',
    description: 'Compliance‑aware playbooks, escalation rules, and tone governance.'
  },
  {
    title: 'Reputation Intelligence',
    description: 'Sentiment tracking and issue detection across locations and services.'
  },
  {
    title: 'AI Accuracy Audits',
    description: 'Audit and correct AI summaries and listings that shape patient decisions.'
  }
];

const timeline = [
  {
    title: 'Risk audit',
    description: 'Review compliance exposure, feedback channels, and escalation gaps.'
  },
  {
    title: 'Governance',
    description: 'Define clinical‑safe response playbooks and approval flows.'
  },
  {
    title: 'Monitoring',
    description: 'Track sentiment and reputation by service line and location.'
  },
  {
    title: 'AI visibility',
    description: 'Audit AI summaries and correct inaccuracies.'
  }
];

const deliverables = [
  'Compliant response templates and approvals',
  'Location and service‑line reporting',
  'Risk and escalation matrix',
  'AI visibility and accuracy audits'
];

const kpis = [
  'Reduction in time‑to‑response for critical reviews',
  'Improved average rating and sentiment trend',
  'Fewer escalations reaching leadership'
];

const example = {
  title: 'Example: Multi‑site healthcare group',
  result:
    'Implemented governance playbooks across 18 locations and reduced escalation events by 40% while improving patient sentiment scores.'
};

export default function Healthcare() {
  return (
    <UseCaseTemplate
      seoTitle="Use Case: Healthcare"
      seoDescription="Reputation management and AI visibility for healthcare organisations."
      path="/use-cases/healthcare"
      title="Healthcare"
      subtitle="We help healthcare brands build trust and manage public feedback responsibly."
      summary={summary}
      challenges={challenges}
      pillars={pillars}
      timeline={timeline}
      deliverables={deliverables}
      kpis={kpis}
      example={example}
    />
  );
}
